export default "__VITE_ASSET__b35a514a__"